import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const previousPathnameRef = useRef(pathname);

  useEffect(() => {
    // Scroll to top only on real route changes.
    // Hash updates (#plans, #app, etc.) should not trigger forced scrolling.
    if (previousPathnameRef.current !== pathname) {
      window.scrollTo(0, 0);
      previousPathnameRef.current = pathname;
    }
  }, [pathname]);

  return null;
}
